import React from 'react';
import styled from 'styled-components';

const StyledDiv = styled.div`
  border: 1px dashed lightgray;
  padding: 10px;
  text-align: center;
  color: lightgray;
`;

interface Props {
  children: any;
  height?: any;
  width?: any;
}

export const PlaceHolder = (props: Props) => {
  const { children, height, width } = props;
  return <StyledDiv style={{ width, height }}>{children}</StyledDiv>;
};
